'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _angular = require('angular');

var _angular2 = _interopRequireDefault(_angular);

var _apiService = require('./apiService');

var _httpInterceptorAuthorization = require('./httpInterceptorAuthorization');

var _httpInterceptorErrors = require('./httpInterceptorErrors');

var _httpInterceptorLanguage = require('./httpInterceptorLanguage');

var _exceptionHandler = require('./exceptionHandler');

var _enums = require('./enums');

var _config = require('./config');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _module = _angular2.default.module('app.core', []).config(_exceptionHandler.exceptionHandler).factory('api', _apiService.apiFactory).factory('httpInterceptorAuthorization', _httpInterceptorAuthorization.httpInterceptorAuthorization).factory('httpInterceptorErrors', _httpInterceptorErrors.httpInterceptorErrors).factory('httpInterceptorLanguage', _httpInterceptorLanguage.httpInterceptorLanguage).constant('Enums', _enums.enums).constant('Breakpoints', _enums.breakpoints).constant('NewsTypes', _enums.newsTypes).constant('DiscountTypes', _enums.discountTypes).constant('ProductTypes', _enums.productTypes).constant('CartMessageTypes', _enums.cartMessageTypes).constant('config', _config.config).constant('defaultLanguage', 'nl').constant('sortProperties', _enums.sortProperties).constant('discountTypeNames', _enums.discountTypeNames).constant('productContexts', _enums.productContexts).constant('supportedLanguages', ['nl', 'fr']);

exports.default = _module.name;


//////////////////
// WEBPACK FOOTER
// ./common/core/index.js
// module id = 706
// module chunks = 0